import React from "react";
import { connect } from "react-redux";
import "../../../../../styles/components/cotizaciones.scss";

import { push } from "connected-react-router";
import { checkAccess, ids, realCheckAccess } from "../../../../../helpers/rolAccess";
import { paths } from "../../../../../config/routes";
import { loadTabs } from "../../../../Header/actions";
import Step1 from "./Step1";
import Step2 from "./Step2";
import Step3 from "./Step3";
import StepsPanel from "./StepsPanel";

const Steps = (props) => [
  <Step1 {...props} />,
  <Step2 {...props} />,
  <Step3 {...props} />,
];

class AgendaSel extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      currentStep: 1,
      step1: {},
      step2: {},
      step3: {},
    };

    this.stepProps = {
      updateStepValues: this.updateStepValues,
    };
  }

  componentDidUpdate = (prevProps) => {
    if (
      (prevProps.userAccessIds === null &&
        Array.isArray(this.props.userAccessIds)) ||
      this.props.currentHeader !== "Cotizaciones "
    ) {
      this.loadTabs();
    }
    if (prevProps.companyId !== this.props.companyId) {
      this.props.dispatch(push(paths.root))
    }
  };

  loadTabs = () => {
    const tabs = [];
    if (checkAccess(ids.declaracionCotizacion, this.props.userAccessIds))
      tabs.push({ text: "Declaración", contentId: 1, isActive: true });
    // if (checkAccess(ids.declaracionCotizacion, this.props.userAccessIds))
    //   tabs.push({ text: "Confirmación", contentId: 2 });
    this.props.dispatch(
      loadTabs(
        "Cotizaciones ",
        "",
        tabs,
        tabs.length ? tabs[0].contentId : null
      )
    );
  };

  updateStepValues = (step, values, toPreviousStep = false) => {
    const { currentStep } = this.state;

    const newStep = toPreviousStep ? currentStep - 1 : currentStep + 1;
    this.setState({ [step]: values, currentStep: newStep });
  };

  render() {
    const { dispatch, companyId } = this.props;
    const { currentStep } = this.state;

    return (
      <div id={"cotizaciones"}>
        <StepsPanel currentStep={currentStep} />

        <div id="cotizaciones-forms">
          {
            Steps({
              ...this.stepProps,
              steps: { ...this.state },
              dispatch,
              companyId,
            })[currentStep - 1]
          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedTab: state.header.contentId,
  currentHeader: state.header.title,
  userAccessIds: state.global.userAccessIds,
  companyId: state.global.companyId,
  sucursalId: state.global.sucursalId,
  // isEditTrabajadores: state.solicitudesAgendaSel.isEditTrabajadores,
});

const mapDispatchToProps = (dispatch) => ({
  dispatch: (action) => {
    dispatch(action);
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AgendaSel);
